import { Navigate } from "react-router-dom";
import { isEmpty } from "lodash";
import Editor from "../pages/editor/Editor";
import HomeGroupAssessorPage from "../pages/homeGroupAssessor/HomeGroupAssessor";
import HomePage from "../pages/home/Home";
import DpoInternal from "../pages/dpo-internal/DpoInternal";
import MyInternal from "../pages/my-internal/MyInternal";
import Login from "../pages/login/Login";

export const LoginRoute = ({ user, config }) => {
  if (isEmpty(user)) return <Login />;
  if (user?.firstLogin === true) return <Navigate to="/change-password" />;
  return (
    <Navigate
      to={`/${config?.pageList?.[user?.role]?.[0] ?? "/no-permissions"}`}
    />
  );
};

export const Home = ({ user, config }) => {
  if (isEmpty(user)) return <Navigate to="/login" />;
  if (user?.firstLogin === true) return <Navigate to="/change-password" />;
  if (config?.pageList?.[user?.role]?.includes("home-page")) {
    return user?.role?.includes("Editor") ? (
      <Editor />
    ) : user?.role?.includes("Compliance") ? (
      <HomeGroupAssessorPage />
    ) : (
      <HomePage />
    );
  } else {
    return (
      <Navigate
        to={`/${config?.pageList?.[user?.role]?.[0] ?? "/no-permissions"}`}
      />
    );
  }
};

export const Internal = ({ user, config }) => {
  if (isEmpty(user)) return <Navigate to="/login" />;
  if (user?.firstLogin === true) return <Navigate to="/change-password" />;
  if (config?.pageList?.[user?.role]?.includes("internal-obligations")) {
    return user?.role?.includes("Compliance") ? (
      <DpoInternal />
    ) : (
      <MyInternal />
    );
  } else {
    return (
      <Navigate
        to={`/${config?.pageList?.[user?.role]?.[0] ?? "/no-permissions"}`}
      />
    );
  }
};

export const PrivateRoute = ({ user, config, Component, page }) => {
  if (isEmpty(user)) return <Navigate to="/login" />;
  if (user?.firstLogin === true) return <Navigate to="/change-password" />;
  if (
    (page === "no-permissions" && !config?.pageList?.[user?.role]?.[0]) ||
    config?.pageList?.[user.role]?.includes(page)
  ) {
    return <Component />;
  } else
    return (
      <Navigate
        to={`/${config?.pageList?.[user?.role]?.[0] ?? "/no-permissions"}`}
      />
    );
};
